export default __webpack_public_path__ + "static/media/resend.f9d14d1b.svg";